export default __webpack_public_path__ + "static/media/detail_mobile_15_5.8c6eaf3a.jpg";